import * as Loadable from 'react-loadable'

import ModalLoading from '../modalLoading'

export default (Loadable as any)({
  loader: () =>
    import(
      /* webpackChunkName: "addItemToCartModal" */ './addItemToCartContainer'
    ),
  loading: ModalLoading,
  webpack: () => [require.resolveWeak('./addItemToCartContainer')],
  modules: ['./addItemToCartContainer']
})
